import React, { useEffect , useState} from 'react';
import moment from 'moment';
import { Row, Typography, Col, Input, Form, DatePicker, Select, Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/pro-duotone-svg-icons';
import locale from 'antd/es/date-picker/locale/pt_BR';
import './gerenciar-pedidos.scss';
import { ListaPedidos } from './lista-pedidos';
import {usePessoas} from '../../services/usePessoas';
import {usePedido} from '../../services/usePedidos';

const { Paragraph} = Typography;


const ListaVendedores = (props) => {
    const {listaPessoas} = usePessoas();
    
    const [options, setOptions] = useState([]);
    useEffect(() =>{
        (async () => {
            const listaDeVendedores = await listaPessoas("VENDEDOR");
            const options = listaDeVendedores.map(vendedor => (<Select.Option key={vendedor.uuid} value={vendedor.uuid}>{vendedor.nome.toUpperCase()}</Select.Option>));
            setOptions(options);
            
        })();
    }, []);
    
    

    return (<Select
                showSearch={true}
                style={{ width: "100%" }}
                placeholder="Todos os vendedores"
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                defaultValue=""
                {... props}
            >
                <Select.Option value="" >Todos</Select.Option>
                {options}
            </Select>
        );
    
}


const ListaStatus = (props) => {
    const {listaStatus} = usePedido();
    
    const [options, setOptions] = useState([]);
    useEffect(() =>{
        (async () => {
            const listaDeStatus = await listaStatus();
            const options = listaDeStatus.map(status => (<Select.Option key={status.slug} value={status.slug}>{status.descricao.toUpperCase()}</Select.Option>));
            setOptions(options);
            
        })();
    }, []);
    
    

    return (<Select
                showSearch={true}
                style={{ width: "100%" }}
                placeholder="Todos os Status"
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                defaultValue=""
                {... props}
            >
                <Select.Option value="%" >Todos</Select.Option>
                {options}
            </Select>
        );
    
}

const ComponenteGerenciarPedidos = (props) => {

    const {tipo, titulo="INSIRA UM TITULO PARA A PAGINA"} = props;

    const [pedidosEncontrados, setPedidosEncontrados] = useState([]);
    const [dadosListaPedidos, setDadosListaPedidos] = useState(false);
    const { buscarPedidos } = usePedido(tipo);
    const [buscandoPedidos, setBuscandoPedidos] = useState(false);
    const [form] = Form.useForm();
    
    

    const hoje = moment();
    const inicioMes = moment(moment().format("YYYY-MM") + "-01", "YYYY-MM-DD")
    const inicioMesPassado = moment(moment().subtract(1, "month").format("YYYY-MM") + "-01", "YYYY-MM-DD");
    const fimMesPassado = moment(moment().format("YYYY-MM") + "-01", "YYYY-MM-DD").subtract(1, 'day');

    const formBuscaHandle = (filtro) => {
        const {periodo} = filtro;
        filtro.de = periodo[0].format("YYYY-MM-DD");
        filtro.ate = periodo[1].format("YYYY-MM-DD");
        buscaPedidos(filtro);
    }

    const buscaPedidosCallback = () => {
        form.submit();
    }

    const buscaPedidos = async (filtro) => {
        console.log(filtro)
        
        setBuscandoPedidos(true);
        try{
            console.log(form);
            const {pedidos:listaPedidos, ...dadosListaPedidos} = await buscarPedidos(filtro);
            setDadosListaPedidos(dadosListaPedidos);
            setPedidosEncontrados(listaPedidos);
        } catch( e ){
            console.log(e);
        } finally{
            setBuscandoPedidos(false);
        }

    }

    return <>
                
        <Row className="linha-titulo">
            <Col>
                <Paragraph  strong={true} >{titulo}</Paragraph>           
            </Col>
        </Row>
        <Form form={form} layout="vertical" className="form-busca" onFinish={formBuscaHandle}>
            <Row gutter={12} className="linhaFormulario">
                <Col xs={24} md={6}>
                    <Form.Item name="termo" label="Termo de Busca" initialValue="">
                        <Input autoComplete="off" />
                    </Form.Item>
                </Col>
                <Col xs={24} md={6}>
                    <Form.Item name="periodo" label="Período" initialValue={[inicioMes,hoje]}>
                        <DatePicker.RangePicker locale={locale} 
                                                style={{width: "100%"}}
                                                format="DD-MM-YYYY"
                                                ranges={{
                                                    "Mês Passado": [inicioMesPassado, fimMesPassado],
                                                    "Hoje":  [moment(), moment()],
                                                    "Este mês": [inicioMes, hoje],
                                                }}
                                                 />
                    </Form.Item>
                </Col>
                <Col xs={24} md={4}>
                    <Form.Item name="vendedor" label="Vendedor" initialValue="">
                            <ListaVendedores></ListaVendedores>
                    </Form.Item>
                </Col>
                <Col xs={24} md={4}>
                    <Form.Item name="status" label="Status" initialValue="%">
                            <ListaStatus></ListaStatus>
                    </Form.Item>
                </Col>
                
                <Col style={{marginTop: "auto", marginBottom: "0"}} flex="auto">
                        <Form.Item name="btn">
                            <Button type="primary" onClick={form.submit} loading={buscandoPedidos} icon={<FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>}>Buscar</Button>
                        </Form.Item>
                </Col>
            </Row>

        </Form>

        <ListaPedidos values={pedidosEncontrados} dadosPedidosEncontrados={dadosListaPedidos} buscaPedidos={buscaPedidosCallback} tipoPedido={tipo}></ListaPedidos>
        
    </>;
}

export {ComponenteGerenciarPedidos}